import { callApi } from '../common/services/baseServices';
import { callApi_file } from '../common/services/attachFile';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import axios from '../axios';

import moment from 'moment';

const ACTIONS = {
    GET_DATA_DELIVERY_SUCCESS: 'GET_DATA_DELIVERY_SUCCESS',
    GET_DATA_DELIVERY_ERROR: 'GET_DATA_DELIVERY_ERROR',
    GET_DATA_DELIVERY_WORKSPACE_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_SUCCESS',
    GET_DATA_DELIVERY_WORKSPACE_ERROR: 'GET_DATA_DELIVERY_WORKSPACE_ERROR',
    COPY_DELIVERY_SUCCESS: 'COPY_DELIVERY_SUCCESS',
    COPY_DELIVERY_ERROR: 'COPY_DELIVERY_ERROR',
    GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS',
    GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS: 'GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS'
};


const updateStatus = (type, data) => ({
    type,
    data,
});

const readWorkspace = (workspace_id) => {
    return async () => {
        const {data} = await axios.post(`/api/deliveries/workspaces/${workspace_id}/read`)
        return data;
    }
}

const getDelivery = (page) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/deliveries/workspaces?page=${page || 1}`;

    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_ERROR, err));
            });
    };
}


const getDeliveryWorkspaceId = (id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    // workspace_id (number)
    // sort (string)
    // order (string)
    let url = `${host.serverTest}api/deliveries/workspaces/${id}/topics?sort=${'topics.title'}&order=${'DESC'}`;

    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_ERROR, err));
            });
    };
}

const copyDelivery = (data) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            workspace_id: -1
        })
    };
    let url = `${host.serverTest}api/topics/${data.topic_id}/copy`;

    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.COPY_DELIVERY_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.COPY_DELIVERY_ERROR, err));
            });
    };
}

const getFilesWorkSpace = (idWorkSpace) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi(`${host.serverTest}api/deliveries/workspaces/${idWorkSpace}/files`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ERROR, err));
            });
    };
}

const getFilesIdWorkSpace = (idWorkSpace, idFile) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'text/plain',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    return (dispatch) => {
        callApi_file(`${host.serverTest}api/deliveries/workspaces/${idWorkSpace}/files/${idFile}`,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ID_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_DATA_DELIVERY_WORKSPACE_FILES_ID_ERROR, err));
                console.log(err);
            });
    };
}

const getCategoryName = (type) => {
    if(type === 'team') {
        return 'Team Topics'
    }
    if(type === 'player') {
        return 'Player Topics'
    }
    if(type === 'game') {
        return 'Game Topics'
    }
    return '';
};

const getURLTopic = (topic) => {
    let url = '';
    if(topic.game) {
        const date = moment(topic.game.game_date, 'YYYY-MM-DD').format('YYYYMMDD');
        url = `/game/${topic.game.id}/${topic.game.home_team.id}/${date}`;
    }
    if(topic.team) {
        url = `/team-report/${topic.team.id}`;
    }
    if(topic.player) {
        url = `/player/${topic.player.id}`;
    }
    return url + `/topic/${topic.id}`;
}

const getColorStatusTopic = (id) => {
    if(id === 1) {
        return '#f53e3f';
    }
    if(id === 2) {
        return '#f2a12f';
    }
    if(id === 3) {
        return '#44d98e';
    }
    return '#ffffff';
};

const handleTextCategory = (value) => {
    if (value.category_name === 'game' && value.game) {
        return `${value.game.game_date ? moment(value.game.game_date, 'YYYY/MM/DD').format('MM/DD') : ''} ${value.game.away_team ? value.game.away_team.team_name_s : ''} - ${value.game.home_team ? value.game.home_team.team_name_s : ''}`;
    }
    if(value.category_name === 'team' && value.team) {
        return value.team.team_name_s ? value.team.team_name_s : '';
    }
    if(value.category_name === 'player' && value.player) {
        return value.player.player_name ? value.player.player_name : '';
    }
    return '';
};

const convertDeliveryWorkspace = (data) => {
    return data.map((items) => {
        return {
            item: [
                { text: items.title },
                { text: getCategoryName(items.category_name) },
                { text: handleTextCategory(items) },
                { text: items.created_at },
                { text: items.updated_at },
                {
                    action: '/img/ic_copy_svg.svg',
                    id: items.id
                }
            ],
            rawItem: items,
        }
    });
}

export { ACTIONS, getDelivery, getDeliveryWorkspaceId, convertDeliveryWorkspace, copyDelivery, getFilesWorkSpace, getFilesIdWorkSpace, getCategoryName, getURLTopic, getColorStatusTopic, readWorkspace};
